import React from "react";
import TextField from "@material-ui/core/TextField";
import _Base from "./_Base";
import {v4 as uuid} from 'uuid';

export default class _TextField extends _Base {

	static propTypes = {
		..._Base.propTypes,
	}

	static defaultProps = {
		margin: 'dense',
		variant: 'outlined',
	}

	constructor(props) {
		super(props);

		// Generate a new autoComplete ID for every TextField instance to prevent browsers from autofilling form fields
		this.autoCompleteToken = uuid();
		this.state.validation_type = this.props.type || this.state.type;
	}

	render() {
		let {type} = this.props;
		let property = this.state;
		let multiline = this.props.multiline;
		let passThroughProps = this.passThroughProps;
		let additionalProps = {};

		if (multiline) {
			additionalProps.rows = multiline;
			additionalProps.style = {marginTop: '20px'};
		}

		if (property.value == null) {
			property.value = "";
		}

		// When passing a custom component, make sure the label doesn't overlap.
		// https://material-ui.com/components/text-fields/#limitations
		if (passThroughProps.InputProps) {
			additionalProps.InputLabelProps = {shrink: property.value.length > 0};
		}

		type = type || property.type_js;

		return (
			<TextField
				{...additionalProps}
				{...passThroughProps}
				autoComplete={this.autoCompleteToken}
				type={type}
				value={property.value}
				error={property.error !== ""}
				helperText={property.error}
				onChange={this.handleDataChange}
				onBlur={!property["ignore_validation"] ? this.handleProcess : null}
				inputProps={{name: property.name}}
				label={this.props.label||property.label}
				fullWidth={true}
				margin={this.props.margin}
				variant={this.props.variant}
				multiline={!!multiline}
			/>
		)
	}
}